import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { FormControlLabel } from '@mui/material';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Checkbox from '@mui/material/Checkbox';
import "./as2-supplier-table-update.css";
import { TableSortLabel } from '@mui/material';
import SupplierSelectComponent from "../../supplier-select-component/SupplierSelectComponent";
import axios from 'axios';
import SearchIcon from '@mui/icons-material/Search';
import { useOktaAuth } from '@okta/okta-react';

const headers = [
  { label: 'Envelope', key: 'ENVELOPE' },
  { label: 'Source Type', key: 'SOURCE_TYPE' },
  { label: 'SAP Lanscape', key: 'SAP_LANDSCAPE' },
  { label: 'EDI Port', key: 'EDI_PORT' },
  { label: 'SAP Client', key: 'SAP_CLIENT' },
  { label: 'Message Code', key: 'MESSAGE_CODE' },
  { label: 'Message Function', key: 'MESSAGE_FUNCTION' },
  { label: 'Message Type', key: 'MESSAGE_TYPE' },
  { label: 'Supplier', key: 'SUPPLIER' },
  { label: 'Delivery MailBox', key: 'DELIVERY_MAILBOX' },
];

const Row = (props) => {
  const { row, handleCheckboxChange, index } = props;
  const [open, setOpen] = useState(false);
  const fieldGroups = [
    headers.slice(0, 4),
    headers.slice(4, 7),
    headers.slice(7, 10),

  ];

  return (
    <>
      <TableRow sx={{
        '& > *': { borderBottom: 'unset' }, width: '100%',
        backgroundColor: index % 2 === 0 ? 'white' : '#d3d3d37a'
      }}>
        <TableCell  >
          <FormControlLabel style={{ margin: 0 }}
            control={<Checkbox checked={row.checked} onChange={(event) => handleCheckboxChange(event, index)} />}
          />
        </TableCell>
        <TableCell style={{ padding: 0 }}>
          <IconButton style={{ outline: 'none' }} aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
        </TableCell>
        {headers.map((item, index) => <TableCell key={index}>{row[item.key] || "-"}</TableCell>)}
      </TableRow>
      <TableRow sx={{
        '& > *': { borderBottom: 'unset' },
        backgroundColor: index % 2 === 0 ? 'white' : '#d3d3d37a'
      }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: '120px' }} colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }} >
              <Grid container spacing={2} >
                {fieldGroups.map((group, groupIndex) => (
                  <React.Fragment key={groupIndex}>
                    {group.map((item, index) => (
                      <Grid item size={{sm:4}} key={index}>
                        <Grid container >
                          <Grid item size={{sm:4}} style={{ whiteSpace: 'nowrap' }}>
                            <Typography variant="h3" gutterBottom >{item.label}</Typography>
                          </Grid>
                          <Grid item size={{sm:4}} >
                            <Typography variant="body2" gutterBottom>{row[item.key] || '-'}</Typography>
                          </Grid>
                        </Grid>
                      </Grid>))}
                  </React.Fragment>))}
              </Grid>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return -1;
  }
  return 0;
}

const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export const SupplierTableUpdate = (props) => {
  const { setSystemError, handleKeyDown, usertype, supplierList } = props;
  const [supplierNumber, setSupplierNumber] = useState(null);
  const [supplierName, setSupplierName] = useState(null);
  const [data, setData] = useState([]);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState();
  const [selectAll, setSelectAll] = useState(false);
  const { oktaAuth } = useOktaAuth();
  const [status, setStatus] = useState('');

  const handleChange = (event) => {
    const selectedStatus = event.target.value;
    setStatus(selectedStatus);
    updateSupplier(selectedStatus);
  };

  useEffect(() => {
    fetchData();
  }, [supplierNumber]);

  const fetchData = async () => {
    if (!supplierNumber) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_EDI_AS2_COMMUNICATION_STATUS_BASE_URL}/api/find-envelope/by-supplier?supplier=${supplierNumber}`,
        {
          headers: {
            'Authorization': 'Bearer ' + oktaAuth.getAccessToken(),
          },
        }
      );
      if (response.data != [] && !response.data[0].message) {
        setData(response.data.map((item) => ({ ...item, checked: false })));
        setSystemError(false);
      } else {
        setData([]);
        setSystemError(false);
      }
    } catch (error) {
      setSystemError(true);
    }
  };

  const supplierChangeHandler = (event) => {
    setSupplierNumber(event.slice(0, 10));
    setSupplierName(event.slice(13));
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    setData(data.map((item) => ({ ...item, checked: isChecked })));
  };

  const handleCheckboxChange = (event, index) => {
    const isChecked = event.target.checked;
    const newData = data.map((item, i) => (i === index ? { ...item, checked: isChecked } : item));
    setData(newData);
    setSelectAll(newData.every((item) => item.checked));
  };

  const updateSupplier = async (status) => {
    const selectedSuppliers = data.filter(item => item.checked);
    const envelope = selectedSuppliers.map(element => element.ENVELOPE)
    if (selectedSuppliers.lenght === 0) {
      return;
    }
    try {
      const text8 = '/app_data/B2Bi/mailbox/EDI_' + `${supplierName}` + '/Outbounds/';
      const url = status === 'active' ?
        `${process.env.REACT_APP_EDI_AS2_COMMUNICATION_STATUS_BASE_URL}/api/code-list/update-text8?text8=${text8}&senderItem=${envelope}`
        :
        `${process.env.REACT_APP_EDI_AS2_COMMUNICATION_STATUS_BASE_URL}/api/code-list/update-text8?senderItem=${envelope}`;
      await axios.put(url, {}, {
        headers: {
          'Authorization': 'Bearer ' + oktaAuth.getAccessToken(),
        },
      })
      fetchData()
    }
    catch (error) {
      setSystemError(true);
    }
  }

  return (
    <>
      <Box px={1} width="92%" >
        <Paper>
          <Container >
            <Grid container pt={5}>
              <Grid item size={{sm:2}}>
                <Typography gutterBottom variant="h3" >Supplier Table</Typography>
              </Grid>
              <Grid size={{sm:10}} item container sm={{ justifyContent: 'flex-end', alignItems: 'center' }} >
                <Grid size={{sm:6}} item sm={{ display:'flex', justifyContent: 'flex-start', alignItems: 'baseline' }}>
                  <Typography gutterBottom variant="h4" whiteSpace='nowrap' pr={5} fontSize='0.9rem'>Supplier Number</Typography>
                  <Grid item size={{xs:6, sm:6, md:8, lg:6, xl:6}}>
                    <SupplierSelectComponent
                      userType={usertype}
                      supplierList={supplierList}
                      supplierChangeHandler={supplierChangeHandler}
                      handleKeyDown={handleKeyDown}
                    />
                  </Grid>
                </Grid>
                <Grid size={{sm:2}}  item sm={{ display:'flex', justifyContent: 'flex-end'}}>
                  <Select
                  value={status}
                  displayEmpty
                  onChange={handleChange}
                  renderValue={(selected) => {
                    if (!selected) {
                      return <span>Select action</span>;
                    }
                    return selected === 'active' ? 'Active' : 'Deactive';
                  }}
                  size="small"
                  sx={{ backgroundColor: '#f0f0f0' }}
                >
      <MenuItem value="active">Active</MenuItem>
      <MenuItem value="deactive">Deactive</MenuItem>
    </Select>
                </Grid>
              </Grid>
            </Grid>
          </Container>
          {supplierNumber ?
            <>
              {data.length === 0 ?
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '70vh', textAlign: 'center' }}>
                  <Typography gutterBottom color='grey' variant="h3">No Records Found</Typography>
                </div>
                :
                <TableContainer component={Paper} style={{ boxShadow: 'none', paddingLeft: '10px', paddingRight: '10px', maxHeight: '400px', overflowY: 'auto' }} >
                  <Table aria-label='collapisble table' size='small' stickyHeader style={{ borderCollapse: 'separate', padding: 0 }}>
                    <TableHead >
                      <TableRow style={{ whiteSpace: "nowrap", }}>
                        <TableCell >
                          <FormControlLabel style={{ margin: 0 }}
                            control={<Checkbox checked={selectAll}
                              onChange={handleSelectAllChange} />}
                          />
                        </TableCell>
                        <TableCell >{''}</TableCell>
                        {headers.map((item, index) => (

                          <TableCell key={index}>
                            <TableSortLabel
                              active={true}
                              direction={orderBy === item.key ? order : 'asc'}
                              onClick={(event) => handleRequestSort(event, item.key)}
                            >
                              {item.label}
                            </TableSortLabel>
                          </TableCell>))}
                      </TableRow>
                    </TableHead>
                    <TableBody >
                      {stableSort(data, getComparator(order, orderBy)).map((row, index) => (
                        <Row key={index} row={row} handleCheckboxChange={handleCheckboxChange} index={index} />
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>}
            </>
            :
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '70vh', textAlign: 'center' }}>
              <Typography gutterBottom color='grey' variant="h3"><SearchIcon></SearchIcon> Oops! No  Data to Display</Typography>
              <Typography gutterBottom color='grey' variant="h3">It's looks like you haven't selected a supplier yet</Typography>
            </div>
          }
        </Paper>
      </Box>
    </>
  );
};